import * as React from 'react';
import {I18n} from '../../i18n/i18n';
import {stylesheet} from 'typestyle';
import {observer} from 'mobx-react';
import {DateRange} from '../../stores/TimeIntervalStore';
import DateRangeSelector from '../../views/DateRangeSelector';
import {NamedDateRangeWithPreviewDateRange} from '../types/Report';
import {LightGreyColor, BlueColor, WhiteColor} from '../../styles/colors';

export interface DateRangeAdderProps {
    namedDateRangeActions: {
        create: () => void;
        rename: (id: string, newName: string) => void;
        remove: (id: string) => void;
        setPreviewDateRange: (idNamedDateRange: string, dateRange: DateRange) => void;
    };
    namedDateRanges: NamedDateRangeWithPreviewDateRange[];
}

export const DateRangeAdder = observer(({namedDateRangeActions, namedDateRanges}: DateRangeAdderProps) => {
    return (
        <div className={dateRangeCss.dateRangeContainer}>
            <div className={dateRangeCss.reportTitle}>
                <I18n i18nKey="report:previewDateRange" />
            </div>
            <div>
                {namedDateRanges.map((namedDateRange) => (
                    <DateRangeBlock key={namedDateRange.id} namedDateRange={namedDateRange} namedDateRangeActions={namedDateRangeActions} />
                ))}
            </div>
        </div>
    );
});

interface DateRangeProps {
    namedDateRange: NamedDateRangeWithPreviewDateRange;
    namedDateRangeActions: {
        create: () => void;
        rename: (id: string, newName: string) => void;
        remove: (id: string) => void;
        setPreviewDateRange: (idNamedDateRange: string, dateRange: DateRange) => void;
    };
}

@observer
class DateRangeBlock extends React.Component<DateRangeProps> {
    private changeDate = (dateRange: DateRange) => {
        this.props.namedDateRangeActions.setPreviewDateRange(this.props.namedDateRange.id, dateRange);
    };

    public render() {
        const {startDate, endDate} = this.props.namedDateRange.previewDateRange;
        return (
            <div className={dateRangeCss.dateRangeBlock}>
                <div className={dateRangeCss.dateRangeInputContainer}>
                    <DateRangeSelector
                        width="100%"
                        startDate={startDate}
                        endDate={endDate}
                        namePrefix="previewDateSelector"
                        onDatesChange={this.changeDate}
                        openDirection="up"
                        small={true}
                        appendToBody={true}
                        noBorder={true}
                    />
                </div>
            </div>
        );
    }
}

const dateRangeCss = stylesheet({
    reportTitle: {
        fontSize: 12,
        fontWeight: 'bold',
        marginBottom: 5,
    },
    dateRangeActionContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: 30,
        borderLeft: '1px solid ' + LightGreyColor,
        transition: '.2s',
        $nest: {
            '&:hover': {
                backgroundColor: LightGreyColor,
            },
        },
    },
    dateRangeInputContainer: {
        cursor: 'text',
        flexGrow: 1,
    },
    dateRangeName: {
        cursor: 'pointer',
        flexGrow: 1,
        padding: '15px 0px 15px 15px',
    },
    dateRangeBlock: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: 15,
        border: '1px solid ' + LightGreyColor,
        borderRadius: 2,
        $nest: {
            '&:last-child': {
                marginBottom: 0,
            },
        },
    },
    addDateRangeButton: {
        padding: 5,
        width: '100%',
        backgroundColor: BlueColor,
        borderRadius: 2,
        color: WhiteColor,
        border: 'none',
    },
    addDateRangeContainer: {
        paddingTop: 15,
    },
    dateRangeContainer: {
        padding: '0px 15px 15px 15px',
    },
});



// WEBPACK FOOTER //
// ./src/report/views/DateRangeAdder.tsx